import { useSelector } from 'react-redux';

export default function useAlreadySelectedPhones(ignoreThisNumber = null) {
    const { friends } = useSelector(state => state.event.friends);
    return friends?.map(f => f.user?.phone).filter(Boolean).filter(p => p != ignoreThisNumber);
}